import Accordion from './accordion.js';

export default class FaqSection extends Accordion {
  constructor(faqSectionEl) {
    super(faqSectionEl, {
      activeClass: 'faq-list__question--visible',
    });
    this.linkableMode = faqSectionEl.dataset.clFaqsLinkable;

    if (this.linkableMode) {
      this.setUpLinking();
    }
  }

  setUpLinking() {

    this.questions.forEach((faqItem, i) => {
      const faqLink = faqItem.children[0];
      if (faqLink !== 'A') console.warn('[faqSection] First child must be an <a> tag.');

      // When the page is initialized,
      // open the faqAnswer that corresponds to the url hash
      if (`#${faqLink.href.split('#')[1]}` === window.location.hash) {
        this.showFaq(i);
      }

      // Prevent scrolling when clicking on an FAQ item.
      faqLink.addEventListener('click', this.preventScrollOnClick.bind(this));
    });
  }

  preventScrollOnClick(e) {
    e.preventDefault();
    // Disabled the faqItem Ids while the has is set
    e.target.parentNode.id = `${e.target.parentNode.id}__disabled`;
    // "Navigate"
    window.location.hash = e.target.href.split('#')[1];
    // Restore the Id
    e.target.parentNode.id = e.target.parentNode.id.replace('__disabled', '');
  }
}
